export default "/images/tutorial_e.webp"